import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  dropdownLoading: false,
  dropdownData: {},
  listDetails: {
    dataSource: [],
    columns: [],
    headers: "",
    totalCars: 0,
    statusList: []
  },
  externalServiceDetails: {},
  filtersData: [],
  pagination: { pageSize: 20, currentPage: 1 },
  vendorsListDetails: {
    loading: false,
    vendorsList: []
  }
};

const fetchDropdownStart = (state) => ({
  ...state,
  dropdownLoading: true
});
const fetchDropdownSuccess = (state, action) => ({
  ...state,
  dropdownLoading: false,
  dropdownData: action.data
});
const fetchDropdownFail = (state) => ({
  ...state,
  dropdownLoading: false
});

const fetchListStart = (state) => ({
  ...state,
  loading: true
});

const fetchListSuccess = (state, action) => ({
  ...state,
  loading: false,
  listDetails: {
    ...action.data
  }
});

const fetchListFail = (state) => ({
  ...state,
  loading: false
});

const fetchFilters = (state, action) => {
  const filterKeys = action.data.reduce((prev, current) => {
    const val = {
      ...prev,
      [current.key]: []
    };

    return val;
  }, {});

  return {
    ...state,
    filtersData: action.data,
    appliedFilters: { ...filterKeys }
  };
};

const externalServiceStart = (state) => ({
  ...state,
  externalServiceDetails: {
    ...state.externalServiceDetails,
    loading: true
  }
});

const externalServiceSuccess = (state, action) => ({
  ...state,
  externalServiceDetails: { ...state.externalServiceDetails, loading: false, ...action.data }
});

const externalServiceFail = (state) => ({
  ...state,
  externalServiceDetails: { loading: false }
});

const fetchOrderVendorStart = (state) => ({
  ...state,
  vendorsListDetails: {
    loading: true
  }
});

const fetchOrderVendorSuccess = (state, action) => ({
  ...state,
  vendorsListDetails: {
    loading: false,
    vendorsList: action.data
  }
});

const fetchOrderVendorFail = (state) => ({
  ...state,
  vendorsListDetails: {
    loading: false
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LIST_START:
      return fetchListStart(state, action);
    case actionTypes.FETCH_LIST_SUCCESS:
      return fetchListSuccess(state, action);
    case actionTypes.FETCH_LIST_FAIL:
      return fetchListFail(state, action);
    case actionTypes.FETCH_WORKSHOP_DROPDOWN_START:
      return fetchDropdownStart(state, action);
    case actionTypes.FETCH_WORKSHOP_DROPDOWN_SUCCESS:
      return fetchDropdownSuccess(state, action);
    case actionTypes.FETCH_WORKSHOP_DROPDOWN_FAIL:
      return fetchDropdownFail(state, action);
    case actionTypes.FETCH_FILTERS:
      return fetchFilters(state, action);
    case actionTypes.FETCH_EXTERNAL_SERVICES_START:
      return externalServiceStart(state, action);
    case actionTypes.FETCH_EXTERNAL_SERVICES_SUCCESS:
      return externalServiceSuccess(state, action);
    case actionTypes.FETCH_EXTERNAL_SERVICES_FAIL:
      return externalServiceFail(state, action);
    case actionTypes.FETCH_ORDER_VENDOR_START:
      return fetchOrderVendorStart(state, action);
    case actionTypes.FETCH_ORDER_VENDOR_SUCCESS:
      return fetchOrderVendorSuccess(state, action);
    case actionTypes.FETCH_ORDER_VENDOR_FAIL:
      return fetchOrderVendorFail(state, action);
    default:
      return state;
  }
};

export default reducer;
